import { formatDate } from '~/utils/common.js';
import { PLAN_FREE, PLANS_SINGLE_LICENCE } from '~/settings.json';
export const mutations = {
  SET_DATA(state, data) {
    state.profileData = data;
  },
  SET_RECENT_SEARCHES(state, data) {
    state.recent_searches = data;
  },
  SET_LIKED_VECTORS(state, data) {
    state.likedVectors = data;
  },
  ADD_LIKE_VECTOR(state, id_vector) {
    state.likedVectors.push(id_vector);
  },
  ADD_LIKE_VECTORS(state, idVectors) {
    state.likedVectors.push(...idVectors);
  },
  SET_DOWNLOADS(state, data = []) {
    state.downloads = data.map((el) => {
      const url = this.$urlBuilder('preview', {
        id: el.id,
        canonizedName: el.slug,
        type: el.idType
      });
      return {
        ...el,
        url,
        link: url
      };
    });
  },
  SET_LATEST_DOWNLOADS(state) {
    state.latestDownloads = state.downloads.length ? [...state.downloads.slice(0, 10)] : [];
  },
  SET_DOWNLOADS_CURRENT_PAGE(state, data) {
    state.downloadsCurrentPage = data;
  },
  SET_DOWNLOADS_PAGES(state, data) {
    state.downloadsPages = data;
  },
  SET_MY_DESIGNS(state, data) {
    const filter = data.filter ? data.filter.toLowerCase() : 'all';
    state.myDesigns[filter] = [...state.myDesigns[filter], ...data.data];
    state.totalDesigns[filter] = data.totalResults;
  },
  SET_BILLING(state, data) {
    state.myBilling = [...state.myBilling, ...data.data];
    state.totalBilling = data.totalResults;
  },
  SET_ACTUAL_PLAN(state, data) {
    state.actualPlan = data;
  },
  SET_COMPLETED_REQUESTS(state, data) {
    state.completedRequests = data;
  },
  SET_FAVORITES(state, data) {
    state.favorites = data.map((el) => {
      return {
        ...el,
        link: this.$urlBuilder('preview', {
          id: el.id,
          canonizedName: el.canonizedName,
          type: el.idType
        })
      };
    });
  },
  SET_FAVORITES_CURRENT_PAGE(state, data) {
    state.favoritesCurrentPage = data;
  },
  SET_FAVORITES_PAGES(state, data) {
    state.favoritesPages = data;
  },
  SET_REQUESTS(state, data) {
    state.requestsList = data.requests;
    state.requestsLimit = data.requestsLimit;
    state.requestsTotalCountable = data.totalCountable;
    state.requestsTotalReleased = data.totalReleased;
  },
  SET_RELEASED_REQUESTS(state, data) {
    state.requestsReleased = data.map((el) => ({
      ...el.vector,
      idRequest: el.id,
      dateEstimatedShow: el.dateEstimatedShow,
      link: this.$urlBuilder('preview', {
        id: el.id,
        canonizedName: el.canonizedName,
        type: el.idType
      })
    }));
  },
  SET_TOTAL_RELEASED_REQUESTS(state, data = 0) {
    state.totalRequestsReleased = data;
  },
  SET_REQUEST_SENT(state, status) {
    state.requestSent = status;
  },
  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
  SET_EMAIL_CHECKING_LOADING(state, status) {
    state.isEmailChecking = status;
  },
  SET_EMAIL_AVAILABLE(state, email) {
    state.emailAvailability.push({ email, status: true });
  },
  SET_EMAIL_NOT_AVAILABLE(state, email) {
    state.emailAvailability.push({ email, status: false });
  },
  SET_MODAL_MODE(state, mode) {
    state.modalMode = mode;
  },
  SET_CREDIT(state, data) {
    state.credit = data;
  },
  SET_SHOW_MESSAGE_MODAL(state, { showMessageModal }) {
    state.showMessageModal = showMessageModal;
  },
  SET_FORM_SUBMISSION(state, { error = false, submited = true }) {
    state.formSubmission.error = error;
    state.formSubmission.submited = submited;
  },
  SET_FEEDBACK_BUTTON_CLICK(state, value) {
    state.sendFeedbackClicked = value;
  },
  SET_USE_DEFAULT_LOADING(state, value) {
    state.useDefaultLoading = value;
  }
};

export const getters = {
  username(state, getters, rootState) {
    return rootState.auth.user.userName;
  },
  avatar(state, getters, rootState) {
    return rootState.auth.user.userAvatar;
  },
  getLikedVectors(state) {
    return state.likedVectors;
  },
  isVectorLiked(state) {
    return function (id) {
      return state.likedVectors.includes(id);
    };
  },
  isEmailAvailable: (state) => (email) => {
    return state.emailAvailability.some((el) => el.email == email && el.status);
  },
  isFree: (state, getters, rootState) => rootState.auth.user?.idPlan === PLAN_FREE,
  loggedInFreeUser(state, getters, rootState) {
    return !rootState.auth.loggedIn || rootState.auth.user.idPlan === 1 ? true : false;
  },
  isLoggedIn(state, getters, rootState) {
    return rootState.auth.user;
  },
  hasBilling: (state) => state.myBilling.length > 0,
  latestDownloads(state) {
    return state.latestDownloads;
  },
  showMessageModal(state) {
    return state.showMessageModal;
  },
  isLoading(state) {
    return state.isLoading;
  },
  isSingleLicence (state, getters, rootState){
    const currentPlan = rootState.auth.user?.idPlan;
    return PLANS_SINGLE_LICENCE.includes(currentPlan);
  },
  isFreePlanOrSingleLicence(state, getters, rootState) {
    return getters.isFree || getters.isSingleLicence;
  },
  getActualPlan(state) {
    return state.actualPlan;
  },
  canRequestDesign: (state) => {
    return state.requestsLimit - state.requestsTotalCountable > 0;
  },
  getUseDefaultLoading(state) {
    return state.useDefaultLoading;
  }
};

export const actions = {
  async LOAD_DATA({ commit }) {
    try {
      const response = await this.$axios.get('user/profile/');
      if (!response.data.error && response.data.data) commit('SET_DATA', response.data.data);
    } catch (error) {
      console.error('User | LOAD_DATA:', error);
    }
  },
  async UPDATE_DATA({ commit }, data) {
    try {
      const {
        address,
        zipCode,
        countryCode,
        city,
        companyName,
        vatId,
        phone,
        firstName,
        lastName,
        weburl
      } = data;
      const response = await this.$axios.post('user/profile/save-user-data/', {
        address,
        zip_code: zipCode,
        country: countryCode,
        city,
        company_name: companyName,
        vat_id: vatId,
        phone,
        firstName,
        lastName,
        weburl
      });
      if (!response.data.error) {
        commit('SET_DATA', data);
        return true;
      } else return false;
    } catch (error) {
      console.error('User | UPDATE_DATA:', error);
      return false;
    }
  },
  async LOAD_RECENT_SEARCHES({ commit }) {
    try {
      const response = await this.$axios.get('user/recent-searches/');
      commit('SET_RECENT_SEARCHES', response.data.logs);
      return true;
    } catch (error) {
      console.error('User | LOAD_RECENT_SEARCHES', error);
      return false;
    }
  },
  async LOAD_LIKED_VECTORS({ commit, state }, vectorIds) {
    try {
      if (this.$auth.loggedIn) {
        const response = await this.$axios.post('user/check-like-vectors/', { vectors: vectorIds });
        if (!response.data.error && response.data.data) {
          let vectors = response.data.data;
          for (let i = 0; i < vectors.length; i++) {
            if (!state.likedVectors.includes(vectors[i])) {
              commit('ADD_LIKE_VECTOR', vectors[i]);
            }
          }
        }
      }
    } catch (error) {
      console.error('User | LOAD_LIKED_VECTORS:', error);
    }
  },
  async SET_LIKE_VECTOR({ commit, state, dispatch }, { idVector, isLiked, bvModal }) {
    try {
      if (!this.$auth.loggedIn) {
        bvModal.show('user-modal');
        dispatch('CHANGE_MODAL_MODE', 'login');
      } else {
        const action = isLiked ? 'unlike' : 'like';
        idVector = parseInt(idVector);
        if (action != 'like') {
          let liked = state.likedVectors.filter((l) => l != idVector);
          commit('SET_LIKED_VECTORS', liked);
        } else {
          if (!state.likedVectors.includes(idVector)) {
            commit('ADD_LIKE_VECTOR', idVector);
          }
        }
        await this.$axios.post('user/like-vector/', { idVector, action });
      }
    } catch (error) {
      console.error('User | SET_LIKE_VECTOR:', error);
    }
  },
  async SEND_FEEDBACK({ commit }, { inputPayload }) {
    commit('SET_FEEDBACK_BUTTON_CLICK', true);
    try {
      const res = await this.$axios.post('/user/profile/send-feedback/', {
        feedback: inputPayload
      });
      if (res.data.error) {
        commit('SET_FORM_SUBMISSION', { error: true });
      } else {
        commit('SET_FORM_SUBMISSION', {});
      }
    } catch (error) {
      commit('SET_FORM_SUBMISSION', { error: true });
    }
    setTimeout(() => {
      commit('SET_FORM_SUBMISSION', { submited: false });
      commit('SET_FEEDBACK_BUTTON_CLICK', false);
    }, 6000);
  },
  async LOAD_DOWNLOADS({ commit }, data = {}) {
    try {
      commit('SET_LOADING', true);
      data.page = !data.page ? 1 : data.page;
      data.perPage = !data.perPage ? 30 : data.perPage;

      if (data.dateFrom && data.dateTo) {
        data.dateFrom = formatDate(data.dateFrom, 'MM/DD/YYYY');
        data.dateTo = formatDate(data.dateTo, 'MM/DD/YYYY');
      }

      const isLatestDownloads = data.page === 1 && !(data.dateFrom || data.dateTo) && !data.text;
      const response = await this.$axios.post('user/profile/downloads/', data);

      if (!response.data.error && response.data.data) {
        const { total, vectors } = response.data.data;

        const totalPages = parseInt(response ? Math.ceil(parseInt(total) / data.perPage) : 0);
        const currentPage = data.page;

        commit('SET_DOWNLOADS', vectors);
        commit('SET_DOWNLOADS_CURRENT_PAGE', currentPage);
        commit('SET_DOWNLOADS_PAGES', totalPages);

        if (isLatestDownloads) {
          commit('SET_LATEST_DOWNLOADS');
        }

        commit('SET_LOADING', false);
      }
    } catch (error) {
      console.error('User | LOAD_DOWNLOADS:', error);
    }
  },
  async LOAD_FAVORITES({ commit, state }, data) {
    try {
      commit('SET_LOADING', true);
      data = !data ? new Object() : data;
      data.page = !data.page ? 1 : data.page;
      data.perPage = !data.perPage ? 30 : data.perPage;

      const response = await this.$axios.post('user/profile/favorites/', data);
      if (!response.data.error && response.data.data) {
        const { total, vectors } = response.data.data;

        const totalPages = parseInt(response ? Math.ceil(parseInt(total) / data.perPage) : 0);
        const currentPage = data.page;
        const idVectors = vectors.map((item) => item.id);

        commit('SET_FAVORITES', vectors);
        commit('SET_FAVORITES_CURRENT_PAGE', currentPage);
        commit('SET_FAVORITES_PAGES', totalPages);
        commit('ADD_LIKE_VECTORS', idVectors);
        commit('SET_LOADING', false);
      }
    } catch (error) {
      console.error('User | LOAD_FAVORITES:', error);
    }
  },
  async LOAD_MY_DESIGNS({ commit }, { page, filter }) {
    commit('SET_LOADING', true);
    try {
      const response = await this.$axios.get(
        `https://makersapi.vexels.com/v1/editions/edition/?page=${page}${
          filter ? `&editionType=${filter}` : ''
        }`
      );
      const data = response.data.results ? response.data.results : [];
      const totalResults = response.data.count ? response.data.count : 0;
      commit('SET_MY_DESIGNS', { data, totalResults, filter });
      commit('SET_LOADING', false);
    } catch (error) {
      commit('SET_LOADING', false);
    }
  },
  async LOAD_REQUESTS({ commit }, data) {
    try {
      data.order = 'DESC';
      const response = await this.$axios.post('user/profile/requests/', data);
      if (!response.data.error && response.data.data) {
        const requests = response.data.data.requests ? response.data.data.requests : [];
        const { requestsLimit, totalCountable, totalReleased } = response.data.data;
        commit('SET_REQUESTS', { requests, requestsLimit, totalCountable, totalReleased });
      }
    } catch (error) {
      console.error('User | LOAD_REQUESTS:', error);
    }
  },
  async LOAD_RELEASED_REQUESTS({ commit }) {
    try {
      let data = {};
      data.order = 'DESC';
      data.status = 'released';
      const response = await this.$axios.post('user/profile/requests/', data);

      if (!response.data.error && response.data.data) {
        const requests = response.data.data.requests ? response.data.data.requests : [];
        const totalReleased = response.data.data.totalReleased
          ? response.data.data.totalReleased
          : 0;
        commit('SET_RELEASED_REQUESTS', requests);
        commit('SET_TOTAL_RELEASED_REQUESTS', totalReleased);
      }
    } catch (error) {
      console.error('User | LOAD_RELEASED_REQUESTS:', error);
    }
  },
  async NEW_REQUEST({ commit }, data) {
    try {
      var formData = new FormData();
      const { description, quote, ref_1, ref_2, attachment_1, attachment_2, attachment_3 } = data;
      formData.append('description', description);
      formData.append('quote', quote);
      formData.append('ref_1', ref_1);
      if (ref_2) formData.append('ref_2', ref_2);
      if (attachment_1) formData.append('attachment_1', attachment_1);
      if (attachment_2) formData.append('attachment_2', attachment_2);
      if (attachment_3) formData.append('attachment_3', attachment_3);
      const response = await this.$axios.post('user/profile/send-request/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      commit('SET_REQUEST_SENT', false);
      if (!response.data.error && response.data.data) {
        commit('SET_REQUEST_SENT', true);
      }
    } catch (error) {
      console.error('User | NEW_REQUEST:', error);
      return false;
    }
  },
  async LOAD_BILLING({ commit }, { page }) {
    commit('SET_LOADING', true);
    try {
      const response = await this.$axios.post('user/profile/billing/', {
        page,
        perPage: 10
      });
      const data = response.data.data.payments ? response.data.data.payments : [];
      const totalResults = response.data.data.total ? response.data.data.total : 0;
      const actualPlan = response.data.data.planInfo ? response.data.data.planInfo : null;
      commit('SET_BILLING', { data, totalResults });
      commit('SET_ACTUAL_PLAN', actualPlan);
      commit('SET_LOADING', false);
    } catch (error) {
      console.error('User | LOAD_BILLING:', error);
      commit('SET_LOADING', false);
    }
  },
  async CHECK_EMAIL_AVAILABILITY({ commit, state }, email) {
    commit('SET_EMAIL_CHECKING_LOADING', true);
    const exists = state.emailAvailability.some((el) => el.email == email);
    if (!exists) {
      try {
        const response = await this.$axios.post('auth/check-email/', { email });
        const available = response.data.data == 'success';
        if (available) {
          commit('SET_EMAIL_AVAILABLE', email);
        } else {
          commit('SET_EMAIL_NOT_AVAILABLE', email);
        }
      } catch (error) {
        console.error('User | CHECK_EMAIL_AVAILABILITY:', error);
      }
    }
    commit('SET_EMAIL_CHECKING_LOADING', false);
  },
  async SIGN_UP({ dispatch, rootGetters }, data) {
    try {
      const response = await this.$axios.post('auth/register/', data);
      if (response.error || response.data.error) {
        return response.data;
      }

      if (rootGetters['vectors/purchaseFlowStatus'] === 'account') {
        dispatch('vectors/CHANGE_PURCHASE_FLOW_STATUS', 'payment', { root: true });
      }

      return { error: false, token: response.data.data.token };
    } catch (error) {
      return { error: true, message: 'There was an error. Please try again later.' };
    }
  },
  CHANGE_MODAL_MODE({ commit }, mode) {
    commit('SET_MODAL_MODE', mode);
  },
  async SEND_SURVEY({ commit }, data) {
    try {
      const response = await this.$axios.post('/survey/complete/', data);
      if (response.data.error) {
        return {
          error: true,
          message: 'There was an error trying to submit form. Please try again later.'
        };
      }
      return {
        error: false,
        message: 'Submitted successfully'
      };
    } catch (error) {
      return {
        error: true,
        message: 'There was an error trying to submit form. Please try again later.'
      };
    }
  },
  async SEND_CANCELLATION({ commit }, data) {
    try {
      const response = await this.$axios.post('/user/cancel-subscription/', data);

      if (response.data.error) {
        return {
          error: true,
          message: 'There was an error trying to submit form. Please try again later.'
        };
      }
      this.$auth.fetchUser(true);
      commit('SET_SHOW_MESSAGE_MODAL', { showMessageModal: true });
      return {
        error: false,
        message: 'Submitted successfully'
      };
    } catch (error) {
      return {
        error: true,
        message: 'There was an error trying to submit form. Please try again later.'
      };
    }
  },
  async LOAD_CREDIT({ commit, state }) {
    try {
      if (!state.credit) {
        const {
          data: { error, data }
        } = await this.$axios.post('/user/credit/');
        if (!error) commit('SET_CREDIT', data);
        else commit('SET_CREDIT', null);
      }
    } catch (error) {
      console.error('User | LOAD_CREDIT:', error);
      commit('SET_CREDIT', null);
    }
  },
  async CHANGE_PASSWORD({}, data) {
    try {
      const response = await this.$axios.post('/user/profile/password/', data);
      if (response.error || response.data.error) {
        return { error: true, message: response.data.data[0].code };
      }
      return { error: false, message: '' };
    } catch (error) {
      console.error('User | CHANGE_PASSWORD:', error);
      return { error: true, message: 'profile.account.profile.errorPassword' };
    }
  },
  async CHANGE_PASSWORD_FORGOT({}, data) {
    try {
      const response = await this.$axios.post('/user/forgot-confirm', data);
      if (response.error || response.data.error) {
        return { error: true, message: response.data.data[0].code };
      }
      return { error: false, message: 'profile.account.profile.emailSent' };
    } catch (error) {
      console.error('User | CHANGE_PASSWORD_FORGOT:', error);
      return { error: true, message: 'profile.account.profile.emailError' };
    }
  },
  async FORGOT_PASSWORD({}, data) {
    try {
      const response = await this.$axios.post('/user/forgot/', data);
      if (response.error || response.data.error) {
        return { error: true, message: response.data.data[0] };
      }
      return { error: false, message: 'profile.account.profile.emailSent' };
    } catch (error) {
      console.error('User | FORGOT_PASSWORD:', error);
      return { error: true, message: 'profile.account.profile.emailError' };
    }
  }
};

export const state = () => ({
  profileData: {},
  recent_searches: [],
  likedVectors: [],
  downloads: [],
  downloadsPages: 0,
  downloadsCurrentPage: 0,
  latestDownloads: [],
  myDesigns: { all: [], logo: [], tsht: [] },
  totalDesigns: { all: 0, logo: 0, tsht: 0 },
  myBilling: [],
  totalBilling: 0,
  actualPlan: null,
  favorites: [],
  favoritesPages: 0,
  favoritesCurrentPage: 0,
  currentPageDesign: 0,
  requestsReleased: [],
  totalRequestsReleased: 0,
  requestsList: [],
  requestsLimit: 0,
  requestsTotalCountable: 0,
  requestsTotalReleased: 0,
  isLoading: false,
  isEmailChecking: false,
  emailAvailability: [],
  modalMode: 'login',
  requestSent: false,
  credit: null,
  showMessageModal: false,
  formSubmission: {
    error: false,
    submited: false
  },
  sendFeedbackClicked: false,
  useDefaultLoading: false
});
